import React from 'react';
import PropTypes from 'prop-types';
import { getStatusBadgeClass } from '../../utils/formatters';

/**
 * Reusable Status Badge component
 */
const StatusBadge = ({ status, type = 'todo' }) => {
  let badgeClass = '';
  
  if (type === 'todo') {
    badgeClass = getStatusBadgeClass(status);
  } else if (type === 'topic') {
    badgeClass = status ? 'badge-closed' : 'badge-open';
  } else if (type === 'user') {
    badgeClass = 'badge-admin';
  } else if (type === 'status') {
    badgeClass = 'badge-status';
  } else if (type === 'active') {
    badgeClass = 'badge-active';
  }

  return (
    <span className={`badge ${badgeClass}`}>
      {type === 'topic' ? (status ? 'Closed' : 'Open') : status}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  type: PropTypes.oneOf(['todo', 'topic', 'user', 'status', 'active']),
};

export default StatusBadge;
